
export interface StringsType {
  domain: string;
  lang: string;
  completeness: number;
  'plural_forms': string;
  locale_data: {
    messages: Record<string, unknown>;
  };
};
export const strings: Record<string,StringsType> = {};

strings['es'] = {
  "locale_data": {
    "messages": {
      "": {
        "domain": "messages",
        "plural_forms": "nplurals=2; plural=(n != 1);",
        "lang": "de"
      },
      "Bad request": [
        ""
      ],
      "Could not start the challenge, check configuration.": [
        ""
      ],
      "Not found": [
        ""
      ],
      "Nonce not found": [
        ""
      ],
      "Not acceptable": [
        ""
      ],
      "Server has wrong template configuration": [
        ""
      ],
      "Internal error": [
        ""
      ],
      "Check logs": [
        ""
      ],
      "Can't complete this challenge": [
        ""
      ],
      "There have been too many attempts to request challenge transmissions and check the TAN code.": [
        ""
      ],
      "Can't be empty": [
        ""
      ],
      "The request was not accepted, try reloading the app.": [
        ""
      ],
      "Challenge not found.": [
        ""
      ],
      "Server templates are missing due to misconfiguration.": [
        ""
      ],
      "There have been too many attempts to request challenge transmissions.": [
        ""
      ],
      "Server is unable to respond due to internal problems.": [
        ""
      ],
      "Invalid pin.": [
        ""
      ],
      "Last TAN code was sent to &quot;%1$s &quot; is not valid anymore.": [
        ""
      ],
      "A TAN code was sent to \"%1$s\"": [
        ""
      ],
      "You should wait until &quot; %1$s &quot; to send a new one.": [
        ""
      ],
      "Try with another address": [
        ""
      ],
      "You can&#39;t change the contact address anymore.": [
        ""
      ],
      "You can change the contact address one last time.": [
        ""
      ],
      "You can change the contact address %1$s more times.": [
        ""
      ],
      "Send new code": [
        ""
      ],
      "We can&#39;t send you the code anymore.": [
        ""
      ],
      "We can send the code one last time.": [
        ""
      ],
      "We can send the code %1$s more times.": [
        ""
      ],
      "Last TAN code can not be used.": [
        ""
      ],
      "Enter the TAN you received to authenticate.": [
        ""
      ],
      "You can&#39;t check the PIN anymore.": [
        ""
      ],
      "You can check the PIN one last time.": [
        ""
      ],
      "You can check the PIN %1$s more times.": [
        ""
      ],
      "TAN code": [
        ""
      ],
      "Check": [
        ""
      ],
      "loading...": [
        ""
      ],
      "Couldn't get information about the validation process": [
        ""
      ],
      "Too many request": [
        ""
      ],
      "Server error": [
        ""
      ],
      "Enter contact details": [
        ""
      ],
      "You will receive an email with a TAN code that must be provided on the next page.": [
        ""
      ],
      "You will receive an SMS with a TAN code that must be provided on the next page.": [
        ""
      ],
      "You will receive an message with a TAN code that must be provided on the next page.": [
        ""
      ],
      "A code has been sent to %1$s": [
        ""
      ],
      "%1$s": [
        ""
      ],
      "Complete the challenge here.": [
        ""
      ],
      "Send email": [
        ""
      ],
      "Send letter": [
        ""
      ],
      "Send SMS": [
        ""
      ],
      "Confirm email": [
        ""
      ],
      "Change email": [
        ""
      ],
      "Confirm address": [
        ""
      ],
      "Change address": [
        ""
      ],
      "Confirm phone": [
        ""
      ],
      "Change phone": [
        ""
      ],
      "Invalid field": [
        ""
      ],
      "Email": [
        ""
      ],
      "Phone": [
        ""
      ],
      "Contact name": [
        ""
      ],
      "Person full name or name of the business": [
        ""
      ],
      "Address": [
        ""
      ],
      "Country": [
        ""
      ],
      "Your full name": [
        ""
      ],
      "Swiss address": [
        ""
      ],
      "Make sure that this address is for Switzerland": [
        ""
      ],
      "Challenge completed": [
        ""
      ],
      "You will be redirected to %1$s": [
        ""
      ],
      "Show challenger setup screen": [
        ""
      ],
      "Show debug info": [
        ""
      ],
      "Internal error, please report.": [
        ""
      ],
      "Preferences": [
        ""
      ],
      "Required": [
        ""
      ],
      "Invalid format": [
        ""
      ],
      "The server doesn't know about this client. Either the URL or the secret is wrong.": [
        ""
      ],
      "Setup new challenge with client ID: &quot;%1$s&quot;": [
        ""
      ],
      "Password": [
        ""
      ],
      "Redirect URL": [
        ""
      ],
      "Start": [
        ""
      ],
      "The application needs to be loaded with 4 request parameters. One or more are missing:": [
        ""
      ],
      "No nonce has been found": [
        ""
      ],
      "The URL is wrong": [
        ""
      ],
      "Maybe the validation check expired.": [
        ""
      ]
    }
  },
  "domain": "messages",
  "plural_forms": "nplurals=2; plural=(n != 1);",
  "lang": "de",
  "completeness": 0
};

strings['de'] = {
  "locale_data": {
    "messages": {
      "": {
        "domain": "messages",
        "plural_forms": "nplurals=2; plural=(n != 1);",
        "lang": "de"
      },
      "Bad request": [
        ""
      ],
      "Could not start the challenge, check configuration.": [
        ""
      ],
      "Not found": [
        ""
      ],
      "Nonce not found": [
        ""
      ],
      "Not acceptable": [
        ""
      ],
      "Server has wrong template configuration": [
        ""
      ],
      "Internal error": [
        ""
      ],
      "Check logs": [
        ""
      ],
      "Can't complete this challenge": [
        ""
      ],
      "There have been too many attempts to request challenge transmissions and check the TAN code.": [
        ""
      ],
      "Can't be empty": [
        ""
      ],
      "The request was not accepted, try reloading the app.": [
        ""
      ],
      "Challenge not found.": [
        ""
      ],
      "Server templates are missing due to misconfiguration.": [
        ""
      ],
      "There have been too many attempts to request challenge transmissions.": [
        ""
      ],
      "Server is unable to respond due to internal problems.": [
        ""
      ],
      "Invalid pin.": [
        ""
      ],
      "Last TAN code was sent to &quot;%1$s &quot; is not valid anymore.": [
        ""
      ],
      "A TAN code was sent to \"%1$s\"": [
        ""
      ],
      "You should wait until &quot; %1$s &quot; to send a new one.": [
        ""
      ],
      "Try with another address": [
        ""
      ],
      "You can&#39;t change the contact address anymore.": [
        ""
      ],
      "You can change the contact address one last time.": [
        ""
      ],
      "You can change the contact address %1$s more times.": [
        ""
      ],
      "Send new code": [
        ""
      ],
      "We can&#39;t send you the code anymore.": [
        ""
      ],
      "We can send the code one last time.": [
        ""
      ],
      "We can send the code %1$s more times.": [
        ""
      ],
      "Last TAN code can not be used.": [
        ""
      ],
      "Enter the TAN you received to authenticate.": [
        ""
      ],
      "You can&#39;t check the PIN anymore.": [
        ""
      ],
      "You can check the PIN one last time.": [
        ""
      ],
      "You can check the PIN %1$s more times.": [
        ""
      ],
      "TAN code": [
        ""
      ],
      "Check": [
        ""
      ],
      "loading...": [
        ""
      ],
      "Couldn't get information about the validation process": [
        ""
      ],
      "Too many request": [
        ""
      ],
      "Server error": [
        ""
      ],
      "Enter contact details": [
        ""
      ],
      "You will receive an email with a TAN code that must be provided on the next page.": [
        ""
      ],
      "You will receive an SMS with a TAN code that must be provided on the next page.": [
        ""
      ],
      "You will receive an message with a TAN code that must be provided on the next page.": [
        ""
      ],
      "A code has been sent to %1$s": [
        ""
      ],
      "%1$s": [
        ""
      ],
      "Complete the challenge here.": [
        ""
      ],
      "Send email": [
        ""
      ],
      "Send letter": [
        ""
      ],
      "Send SMS": [
        ""
      ],
      "Confirm email": [
        ""
      ],
      "Change email": [
        ""
      ],
      "Confirm address": [
        ""
      ],
      "Change address": [
        ""
      ],
      "Confirm phone": [
        ""
      ],
      "Change phone": [
        ""
      ],
      "Invalid field": [
        ""
      ],
      "Email": [
        ""
      ],
      "Phone": [
        ""
      ],
      "Contact name": [
        ""
      ],
      "Person full name or name of the business": [
        ""
      ],
      "Address": [
        ""
      ],
      "Country": [
        ""
      ],
      "Your full name": [
        ""
      ],
      "Swiss address": [
        ""
      ],
      "Make sure that this address is for Switzerland": [
        ""
      ],
      "Challenge completed": [
        ""
      ],
      "You will be redirected to %1$s": [
        ""
      ],
      "Show challenger setup screen": [
        ""
      ],
      "Show debug info": [
        ""
      ],
      "Internal error, please report.": [
        ""
      ],
      "Preferences": [
        ""
      ],
      "Required": [
        ""
      ],
      "Invalid format": [
        ""
      ],
      "The server doesn't know about this client. Either the URL or the secret is wrong.": [
        ""
      ],
      "Setup new challenge with client ID: &quot;%1$s&quot;": [
        ""
      ],
      "Password": [
        ""
      ],
      "Redirect URL": [
        ""
      ],
      "Start": [
        ""
      ],
      "The application needs to be loaded with 4 request parameters. One or more are missing:": [
        ""
      ],
      "No nonce has been found": [
        ""
      ],
      "The URL is wrong": [
        ""
      ],
      "Maybe the validation check expired.": [
        ""
      ]
    }
  },
  "domain": "messages",
  "plural_forms": "nplurals=2; plural=(n != 1);",
  "lang": "de",
  "completeness": 0
};

